export default __webpack_public_path__ + "static/media/favicon.e9d4795b.svg";